export default function phoneNumberFormatter(phoneNumber) {
    if (typeof phoneNumber !== "string") {
        return null;
    }
    const countryCodePrefix = phoneNumber.substr(0, 2);
    const phoneNumberSuffix = phoneNumber.slice(2, phoneNumber.length);
    return `+${countryCodePrefix}-${phoneNumberSuffix}`;
}

